module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Timer-2e4c2377d4ef7bc79344e851c59619e0.svg";